The updated list of disabled feature codes for this hirer-partner combination.
